import { createFileRoute } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { TrainingStatusSection } from '@/components/compliance/people/EmployeeComplianceSections'
import { useEmployeeCenterDashboard } from '@/components/employee-center/EmployeeCenterEmployeeShell'
import { trpc } from '@/lib/trpc'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/training',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const queryClient = useQueryClient()
  const {
    dashboard,
    onSubmitTraining,
    submitTrainingPending,
  } = useEmployeeCenterDashboard()

  return (
    <TrainingStatusSection
      trainingRecords={dashboard.trainingRecords}
      onSubmitTraining={onSubmitTraining}
      submitTrainingPending={submitTrainingPending}
      enableDetailLinks
      displayStyle='table'
      onTrainingRecordsChanged={() => {
        queryClient.invalidateQueries({
          queryKey: trpc.employeeCenter.myDashboard.queryKey(),
        })
      }}
    />
  )
}
